import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper";
import axios from "axios";
// install Swiper modules
SwiperCore.use([Navigation, Pagination, EffectFade]);

// API configuration constants
const API_URL = "https://test.campfr.com/api/list_featured_workshops/";
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

// Log the API token to the console to confirm its value
// console.log("API_TOKEN:", API_TOKEN);

function FeaturedWorkshops() {

  
  // Define a color mapping for the 10 artforms.
  const artformColors = {
    music: "#367591",
    sound: "#009FE3",
    film: "#FBF299",
    art: "#E6007E",
    environment: "#6EBC86",
    writing: "#7B6A58",
    activism: "#E24259",
    performance: "#725283",
    video: "#ABD194",
    vr: "#4D4C4C"
  };

  const heroslide4 = {
    slidesPerView: 1,
    speed: 1500,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
    roundLengths: true,
    effect: 'fade',
    navigation: {
      nextEl: '.hero-next3',
      prevEl: '.hero-prev3',
    },
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: ".hero-two-pagination",
      clickable: true,
      renderBullet: function(index, className) {
        return '<span class="' + className + '">' + 0 + (index + 1) + "</span>";
      }
    }
  };

  // State management for data, loading status, and error handling
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */
  
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });

        // Wait until response.data is defined
        if (!response.data) {
          console.warn("API Response is undefined or null.");
          return;
        }

        console.log("API Response:", response.data);

        // Update component state with fetched data
        const workshopsArr = Array.isArray(response.data) 
          ? response.data 
          : Object.values(response.data);
        setWorkshops(workshopsArr);
        setLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error); 

  // Map over the fetched workshops to render slides
  const listItems = workshops.map((workshop, index) => {

    const tutorColorClasses = ['txt-gradient-1','txt-gradient-2','txt-gradient-3','txt-gradient-4','txt-gradient-5','txt-gradient-6'];
    const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];


    // Convert the comma-separated artforms string into an array
    const artformTags = workshop.artforms.split(',').map((art, idx) => {
      const trimmedArt = art.trim();
      return (
        <span
          key={idx}
          style={{
            backgroundColor: artformColors[trimmedArt],
            color: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "0.9rem",
            marginRight: "4px",
            marginBottom: "4px"
          }}
        >
          {trimmedArt}
        </span>
      );
    });

    //if you ever want to put the artform tags back in:
    // <div className="featured_artforms_container">{artformTags}</div>

    return (
      <SwiperSlide key={index} className="swiper-slide">
        <div className="slider-bg-1" style={{ backgroundImage: `url(${workshop.course_image})` }}>
          <div className="container">
            <div className="row d-flex justify-content-lg-start justify-content-center align-items-center">
              <div className="col-xl-7 col-lg-7">
                <div className="hero4-content">

                  <h1 className={workshop.title_class}>
                    {workshop.title_with}{" "}
                    <span className={randomTutorClass}>{workshop.tutors}</span>
                  </h1>
                
                  <p>
                  
                  {workshop.short_description} <span className="featuredPlaces">{workshop.places} {workshop.placesword}</span>
                  </p>
                  <Link
                    to={workshop.ctype + "/" + workshop.short_url}
                    className="button-fill-primary all-package-btn"
                  >
                    Read more
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    );
  });

  return (
    <>
      <div className="hero-area hero-style-four">
        <div className="hero-main-wrapper position-relative">
          <Swiper className="swiper hero-slider-four" {...heroslide4}>
            <div className="swiper-wrapper">
              {listItems}
            </div>
          </Swiper>
          <div className="slider-arrows text-center d-lg-flex flex-column d-none gap-5">
            <div className="hero-prev3" tabIndex={0} role="button" aria-label="Previous slide">
              <i className="bi bi-arrow-left" />
            </div>
            <div className="hero-next3" tabIndex={0} role="button" aria-label="Next slide">
              <i className="bi bi-arrow-right" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeaturedWorkshops;
